import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";

// Fetch Weddings
export const fetchWeddings = createAsyncThunk(
  "weddings/fetchWeddings",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      // Dummy API call for fetching weddings
      const response = await get("wedding/list", "", {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      return response.result || [];
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Save a Wedding
export const saveWedding = createAsyncThunk(
  "weddings/saveWedding",
  async (wedding, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      // Dummy API call for saving a wedding
      const response = await post("wedding/save", wedding, {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      if (response.data) {
        dispatch(addWedding(response.data));
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Update a Wedding
export const updateWedding = createAsyncThunk(
  "weddings/updateWedding",
  async (wedding, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      // Dummy API call for updating a wedding
      const response = await post("wedding/update", wedding, {});
      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }
      dispatch(editWedding(response.data));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

// Reducer actions for adding and editing weddings
export const addWedding = (wedding) => ({
  type: "weddings/addWedding",
  payload: wedding,
});

export const editWedding = (updatedWedding) => ({
  type: "weddings/editWedding",
  payload: updatedWedding,
});

// Wedding Slice
const weddingSlice = createSlice({
  name: "weddings",
  initialState: {
    weddings: [
      {
        id: 1,
        weddingName: "John and Jane",
        weddingDate: "2025-02-14",
        location: "Central Park",
        names: { brideName: "Jane Doe", groomName: "John Doe" },
        images: [],
        reserveNow: { fullName: "", attending: "", persons: 0 },
        bankDetails: "Bank Account: 1234567890, Routing: 987654321",
        googleMapsAddress: "https://goo.gl/maps/xyz123",
        eventSchedule: [
          {
            eventName: "Ceremony",
            time: "6:00 PM",
            description: "At the park gazebo",
          },
          {
            eventName: "Reception",
            time: "8:00 PM",
            description: "In the banquet hall",
          },
        ],
      },
      {
        id: 2,
        weddingName: "Mike and Anna",
        weddingDate: "2025-03-20",
        location: "Beachside Resort",
        names: { brideName: "Anna Smith", groomName: "Mike Johnson" },
        images: [],
        reserveNow: { fullName: "", attending: "", persons: 0 },
        bankDetails: "Bank Account: 2233445566, Routing: 6655443322",
        googleMapsAddress: "https://goo.gl/maps/abc456",
        eventSchedule: [
          {
            eventName: "Welcome Drinks",
            time: "4:00 PM",
            description: "At the beach bar",
          },
          {
            eventName: "Dinner",
            time: "7:00 PM",
            description: "In the main dining hall",
          },
        ],
      },
    ],
    loading: false,
    error: null,
  },
  reducers: {
    addWedding: (state, action) => {
      if (action.payload) {
        state.weddings.push(action.payload);
      }
    },
    editWedding: (state, action) => {
      const index = state.weddings.findIndex(
        (wedding) => wedding.id === action.payload.id
      );
      if (index !== -1) {
        state.weddings[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWeddings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWeddings.fulfilled, (state, action) => {
        state.loading = false;
        state.weddings = action.payload;
      })
      .addCase(fetchWeddings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default weddingSlice.reducer;
